(() => {
  const selector = 'img[loading="lazy"]:not([data-ds-priority-managed])';
  const managedRoots = '.ds-site, media-gallery, .product-information';

  const promote = (image, priority = 'auto') => {
    if (!(image instanceof HTMLImageElement)) return;
    image.fetchPriority = priority;
    image.loading = 'eager';
  };

  const nearObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            promote(entry.target, 'auto');
            nearObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '480px 35%', threshold: 0.01 }
      )
    : null;

  const visibleObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            promote(entry.target, 'high');
            visibleObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px', threshold: 0.01 }
      )
    : null;

  const manage = (image) => {
    if (!(image instanceof HTMLImageElement) || image.dataset.dsPriorityManaged === 'true') return;
    if (!image.closest(managedRoots)) return;

    image.dataset.dsPriorityManaged = 'true';
    if (!image.hasAttribute('fetchpriority')) image.fetchPriority = 'low';
    if (!image.hasAttribute('decoding')) image.decoding = 'async';

    if (!nearObserver || !visibleObserver) {
      promote(image, 'auto');
      return;
    }

    nearObserver.observe(image);
    visibleObserver.observe(image);
  };

  const scan = (root = document) => {
    if (root instanceof HTMLImageElement && root.matches(selector)) manage(root);
    root.querySelectorAll?.(selector).forEach(manage);
  };

  scan();

  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
